/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Tlm_1Inputs */

const en_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`content`)
};

const ar_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحتوى`)
};

const bn_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`content`)
};

const de_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt`)
};

const es_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contenido`)
};

const fr_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu`)
};

const pt_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`conteúdo`)
};

const zh_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容`)
};

const tr_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`içeriği`)
};

const ru_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`контент`)
};

const pl_svc_full_stack_web_apps_tlm_1 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treść`)
};

/**
* | output |
* | --- |
* | "content" |
*
* @param {Svc_Full_Stack_Web_Apps_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_tlm_1 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_tlm_1(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_tlm_1(inputs)
	return en_svc_full_stack_web_apps_tlm_1(inputs)
});
export { svc_full_stack_web_apps_tlm_1 as "svc_full-stack-web-apps_tlm_1" }